<template>
  <yandex-map
    :settings="settings"
    :coords="center"
    :zoom.sync="zoom"
    :controls="controls"
    ymap-class="ymap-calc"
    @map-was-initialized="mapLoaded"
  />
</template>

<script>
import {
  MAP_CENTER,
  balloonLayout,
  multiRouteOptions,
  ymapSettings,
} from './constants'

export default {
  name: 'CalcYMap',
  props: {
    load: {
      type: String,
      default: '',
    },
    unload: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      zoom: 8,
      controls: ['zoomControl', 'fullscreenControl'],
      center: MAP_CENTER,
      settings: ymapSettings,
      map: null,
      multiRoute: null,
    }
  },
  watch: {
    load() {
      this.onWatch()
    },
    unload() {
      this.onWatch()
    },
  },
  methods: {
    mapLoaded(e) {
      e.options.set('suppressMapOpenBlock', true)
      this.map = e
    },
    onWatch() {
      if (this.map) {
        this.map.geoObjects.removeAll()
        this.multiRoute = null
      }
      this.setRoute()
    },
    setRoute() {
      this.$emit('loading', true)
      const { load, unload } = this

      if (load && unload && window.ymaps && this.map) {
        const balloon = window.ymaps.templateLayoutFactory.createClass(
          ...balloonLayout,
        )
        const opt = multiRouteOptions([load, unload], balloon, 3)

        this.multiRoute = new window.ymaps.multiRouter.MultiRoute(...opt)
        this.map.geoObjects.add(this.multiRoute)
        this.multiRoute.events.once('update', this.stopLoading)
        this.multiRoute.events.add('activeroutechange', this.setDistance)
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      this.$emit('loading', false)
    },
    setDistance() {
      const activeRoute = this.multiRoute.getActiveRoute()

      if (activeRoute) {
        const distance = activeRoute.properties.get('distance').text

        this.$emit('distance', parseInt(distance.replace(/\D+/g, ''), 10))
      }
    },
  },
}
</script>

<style lang="sass">
.ymap-calc
  height: 290px
  background: #c4c4c4
</style>
